export enum PaysafeEnvironment {
  Test = 'TEST',
  Live = 'LIVE',
}
